module.exports = __webpack_public_path__ + "static/media/Fatai Tella.2a57a0be.jpeg";